import { IEvaluateAbsenceWarningDTO } from 'shared/domain/dtos';
import { IAbsenceWarningRepository } from 'shared/domain/repositories';

export default class EvaluateAbsenceWarningUseCase {
  constructor(private absenceWarningRepository: IAbsenceWarningRepository) {}

  public async execute({ customerId, scheduleId }: IEvaluateAbsenceWarningDTO) {
    return this.absenceWarningRepository.evaluate({ customerId, scheduleId });
  }
}
